module.exports = __webpack_public_path__ + "static/media/mallmap.6d4d8d54.svg";